export const useSubCategory = () =>
  useState<boolean>('subCategory', () => false)
